import { ThemeProvider } from '@mui/material/styles';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Fallback } from '@components/TechPages/Fallback';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import RecoilProvider from './Components/providers/RecoilProvider';
import { theme } from '@config/theme';
import { UserProvider } from '@contexts/UserContext';
import { Global } from '@emotion/react';
import { globalStyles, StyledToastContainer } from './globalStyles';

import { registerChunkErrorListener } from '@utils/chunkReloadGuard';

if (__VENDOR_GA__) {
  import('@integrations/ga').then((m) => m.initGA());
}
if (__VENDOR_CLARITY__) {
  import('@integrations/clarity').then((m) => m.initClarity());
}
if (__VENDOR_HOTJAR__) {
  import('@integrations/hotjar').then((m) => m.initHotjar());
}

registerChunkErrorListener();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'online',
      refetchOnWindowFocus: false,
      retry: false,
    },
    mutations: {
      networkMode: 'online',
    },
  },
});

const router = createBrowserRouter([{ path: '*', Component: App }]);

const container = document.getElementById('root');

const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={Fallback}>
      <QueryClientProvider client={queryClient}>
        <RecoilProvider>
          <ThemeProvider theme={theme}>
            <UserProvider>
              <Global styles={globalStyles} />
              <StyledToastContainer
                position="bottom-left"
                enableMultiContainer
                stacked
                closeButton={false}
                autoClose={10000}
                pauseOnHover
                pauseOnFocusLoss={false}
                draggable
              />
              <RouterProvider router={router} />
              <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
            </UserProvider>
          </ThemeProvider>
        </RecoilProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
